import React, { useState, useEffect } from 'react';
import './RightSidebar.css'; 
import ZapierChatBot from '../ZapierChatBot/ZapierChatBot'
import MessageBox from "../MessageBox/MessageBox";
import VideoDocumentation from "../VideoDocumentation/VideoDocumentation";
import ProductDocumentation from '../ProductDocumentation/ProductDocumentation';
import CallBackRequest from '../CallBackReqest/CallBackRequest';

const RightSidebar = () => {

  const [active, setActive] = useState(null);

  const handleClick = (key) => {
    setActive(prev => (prev === key ? null : key));
  };


  return (
    <div className="right-sidebar">
      

      <div className="bottom-section">
        <div className="capsule-container">
             <CallBackRequest
                isActive={active === 'CallBack'}
                isDisabled={active && active !== 'CallBack'}
                onClick={() => handleClick('CallBack')}
            />
            <VideoDocumentation  
                isActive={active === 'VideoDoc'}
                isDisabled={active && active !== 'VideoDoc'}
                onClick={() => handleClick('VideoDoc')}
            />
            <ProductDocumentation
              isActive={active === 'ProcuctDoc'}
              isDisabled={active && active !== 'ProcuctDoc'}
              onClick={() => handleClick('ProcuctDoc')}
            />
            <div className="capsule-separator" />
            <ZapierChatBot 
                isActive={active === 'ChatBot'}
                isDisabled={active && active !== 'ChatBot'}
                onClick={() => handleClick('ChatBot')}
            />
            <MessageBox
                isActive={active === 'Message'}
                isDisabled={active && active !== 'Message'}
                onClick={() => handleClick('Message')}                
            />
          </div>
      </div>
    </div>
  );
};

export default RightSidebar;
